<template>
  <pinned-message :hidden="user?.is_admin || !isScreenL" />
  <swiper
    v-bind="$attrs"
    :slides-per-view="1"
    :space-between="20"
    :pagination="false"
    :navigation="false"
    :scrollbar="false"
    :loop="true"
    :thumbs-swiper="'.swiper-bullets .swiper-wrapper'"
    type="mainLotGallery"
    class="swiper-wrapper with-main-bullets main-lot-gallery-swiper"
    init="false"
    @swiper-init="onSliderInit"
  >
    <swiper-slide v-for="(file, i) in files" :key="`${i}-${file.type})`" class="swiper-slide">
      <img
        v-if="file.type == LotFileTypes.IMAGE"
        :src="file.src"
        class="img"
        :alt="file.src"
        :width="gallerySize.width"
        :height="gallerySize.height" />
      <a v-else-if="file.type == LotFileTypes.PDF" :href="file.src" class="magnifier-zoom-image" target="_blank">
        <img
          src="@/assets/images/common/lot-pdf.svg"
          class="img"
          alt="pdf"
          :width="gallerySize.width"
          :height="gallerySize.height" />
      </a>
      <a v-else-if="file.type == LotFileTypes.VIDEO" :href="file.src" class="magnifier-zoom-image" target="_blank">
        <img
          src="@/assets/images/common/lot-video.svg"
          class="img"
          alt="video"
          :width="gallerySize.width"
          :height="gallerySize.height" />
      </a>
    </swiper-slide>
  </swiper>

  <swiper
    v-if="files.length > 1"
    :slides-per-view="5"
    :space-between="10"
    :pagination="false"
    :navigation="false"
    :scrollbar="false"
    :loop="files.length > 5"
    type="mainLotGalleryBullets"
    class="swiper-wrapper swiper-bullets"
    init="false"
    @swiper-init="onSliderInitThumbs"
  >
    <swiper-slide v-for="(file, i) in files" :key="`${i}-${file.type})`" class="swiper-pagination-bullet swiper-slide"></swiper-slide>
  </swiper>
</template>

<script setup lang="ts">
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { computed, nextTick, ref, watch } from "vue";
  import Swiper from "@/components/_partials/Swiper.vue";
  import type { Swiper as SwiperSlider } from "swiper/types";
  import { LotFileTypes } from "@/enum";
  import { isObject } from "lodash";
  import { isScreenL } from "@/utils/media-size";
  import { IMessage } from "@/models";
  import PinnedMessage from "@/components/_partials/PinnedMessage.vue";

  const swiperMain = ref<SwiperSlider | null>(null);
  const swiperThumbs = ref<SwiperSlider | null>(null);

  const newMessage = ref<IMessage | null>(null);
  const user = computed(() => auctionStore.user);

  const gallerySize = computed(() => {
    if (auctionStore.user?.is_admin) {
      return { width: 290, height: 373 };
    } else {
      return { width: 403, height: 517 };
    }
  });

  const auctionStore = useAuctionStore();
  const activeLot = computed(() => (auctionStore.activeLot?.id ? auctionStore.activeLot : auctionStore.fakeActiveLot));
  const files = computed(() => {
    return isObject(activeLot.value?.files) ? Object.values(activeLot.value?.files) || [] : [];
  });

  const onSliderInit = (swiper: SwiperSlider) => {
    swiperMain.value = swiper;
  };

  const onSliderInitThumbs = (swiper: SwiperSlider) => {
    swiperThumbs.value = swiper;
  };

  watch(
    () => activeLot.value?.files,
    (nv) => {
      swiperMain.value?.update();
      swiperMain.value?.slideTo(0);
      swiperThumbs.value?.update();
    },
    { deep: true, immediate: true }
  );
</script>

<style>
  @media (min-width: 769px) {
    /* TODO: Need fix it after 10.10.25 */
    .custom-swiper.swiper-bullets {
      display: none;
    }
  }
</style>